module.exports = __webpack_public_path__ + "img/RON.b14d54ed.svg";